import { Component, Input } from '@angular/core'

@Component({
  selector: 'vdr-icon',
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss'
})
export class IconComponent {
  @Input() className?: string = ''
  @Input() name:
    | 'home-smile'
    | 'building'
    | 'plate'
    | 'clipboard'
    | 'chart'
    | 'users-group'
    | 'pie-chart'
    | 'dialog'
    | 'ticket-sale'
    | 'speaker'
    | 'sort'
    | 'dollar'
    | 'settings'
    | 'document'
    | 'close'
    | 'trash'
    | 'upload'
    | 'chevron-right'
    | 'map'
    | 'pie-chart-2'
    | 'keyword'
    | 'bell'
    | 'refresh'
    | 'layers'
    | 'lock'
    | 'download'
    | 'history'
    | 'check'
    | 'invest'
    | 'user-check'
    | 'gps'
    | 'hotel'
    | 'edit'
    | 'introduction'
    | 'request'
    | 'calendar'
}
